import React from "react";
import Error from "../../../../components/Error";
import Offer from "../../../../components/offers/Offer";
import offersController from "../../../../lib/offers/offersController";
import PrivateRequestAccessController from "../../../../lib/offers/privateAccessRequestControllers";
import serializable from "../../../../lib/serializable";
import ServerProps from "../../../../lib/serverProps";
import UsersController from "../../../../lib/users/usersController";
import Access from "../../../../utils/access";
import { privateRequestState } from "../../../../utils/constant";

const OfferPage = ({ state, offer, data }) =>
  (!offer.id && !offer.new) ||
  (!Access.can("manage", state.user) && offer.new) ? (
    <Error statusCode={404} state={state} />
  ) : (
    <Offer.Page state={state} data={data} offer={offer} />
  );

export async function getServerSideProps({ query, req, res }) {
  const offer =
    query.slug !== "new"
      ? await offersController.findById(query.id)
      : { status: "draft", new: true };

      const state = await ServerProps.getState(req);
      const data = {};

      data.raised = await offersController.getRaised(query.id);
      data.loginRequired = query.loginRequired;
  if (state.user?.id && offer?.id) {
    data.interest = await UsersController.getOfferInterest(
      state.user.id,
      offer.id
    );
    data.payments = await UsersController.getTotalPayments(
      state.user.id,
      offer.id
    );
    data.verif = await UsersController.getWholesaleVerification(state.user.id);
    data.isTeamMember = await offersController.getTeamMember(
      state.user.id,
      offer?.id
    );
  }

  if (offer?.id) {
    data.paymentList = await offersController.getPaymentList(offer.id);
    data.publicQuestions = await offersController.getPublicQuestions(offer.id);
    data.offerTeamMembers = await offersController.getOfferTeamMembers(
      offer.id
    );

data.offerTeamMembersForSelect = data.offerTeamMembers?.map(
  (member) =>
    member.userId && {
      value: member?.UserId,
      label: member?.name,
    }
);
    data.rewards = await offersController.getOfferRewards(offer.id);
    data.offerUpdates = await offersController.getOfferUpdates(offer.id);
  }

  const eoiUser = data?.interest;
  try {
    // handling private offers access for users
    if (
      (offer.status == "private" || offer.status == "private ended") &&
      state?.user?.role !== "admin" &&
      offer?.UserId != state?.user?.id &&
      !data.isTeamMember?.id &&
      !eoiUser
    ) {
      // check whether user has request for access for this offer previously
      const response = await PrivateRequestAccessController.findOne(
        offer.id,
        state.user.id
      );

      if (response?.status !== privateRequestState.accepted) {
        if (offer.status == "private ended") {
          data["privateRequestState"] = privateRequestState.privateEnded;
        } else {
          data["privateRequestState"] = response
            ? response?.status
            : privateRequestState.applyNow;
        }
      }
    }
  } catch (error) {
    data["privateRequestState"] = !state.user.id
      ? privateRequestState.privateOfferWithoutLogin
      : privateRequestState.notFetched;
  }

  return {
    props: {
      state,
      offer: serializable(offer),
      data: serializable(data),
    },
  };
}

export default OfferPage;
